export default {
  data() {
    return {
      activeReport: {
        open: false
      }
    }
  },
  methods: {
    openReport(type, type_id) {
      let self = this;
      self.activeReport.type_id = type_id;
      self.activeReport.type = type;
      self.activeReport.open = true;
      self.$forceUpdate();
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ReportingMixin/index.js